import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";

const HelpCenterMenuComponent = ({
  tabs,
  selectedTab,
  setSelectedTab,
  styles,
  toggleMenu,
}) => {
  return (
    <View>
      {tabs.map((tab) => (
        <TouchableOpacity
          key={tab.key}
          style={[
            styles.buttonStyle,
            {
              backgroundColor:
                selectedTab === tab.key
                  ? AppColors.grayColor_D9D9D9
                  : "transparent",
            },
          ]}
          onPress={() => {
            setSelectedTab(tab.key);
            toggleMenu();
          }}
        >
          <View style={styles.buttonInner}>
            <View style={styles.topLineStyle} />
            <Text
              style={[
                styles.buttonTextStyle,
                AppFontStyle.BOLD_ANYBODY_14,
                {
                  color:
                    selectedTab === tab.key
                      ? AppColors.blue_165AB8
                      : AppColors.white,
                },
              ]}
            >
              <Text
                style={{
                  borderBottomColor:
                    selectedTab === tab.key
                      ? AppColors.blue_165AB8
                      : AppColors.white,
                  borderBottomWidth: 1,
                }}
              >
                {tab.label}
              </Text>
            </Text>
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default HelpCenterMenuComponent;
